import React, { useEffect, useState } from "react";
// import getTeamMembersData from "../components/team-members/TeamMembersCardData.json";
import TeamMembersCard from "../components/team-members/TeamMembersCard";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Layout from "../common/Layout";
import { Helmet } from "react-helmet";
import axios from "axios";

const TeamMembersPage = () => {

  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await axios.get(
          "https://portal.ebs365.info/api/sites/3/list/team"
        );
        setHome(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSiteSettings();
  }, []);

 

    let teamMembers = [];
  if (home && home.data) {
    teamMembers = home.data;
  }

  //  console.log("teamender", teamMembers);
 

  return (
    <>
      <Helmet>
        <title>Employees || RSS Security and Investigations Pty Ltd</title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle="Our Employees"
          rootPath="/"
          parentPath="Home"
          currentPath="Our Employees"
        />
        {/* Team Section Start */}
        <div className="team-sec pt-100 pb-70">
          <div className="container">
            <div className="row">
              {
                  teamMembers.map((data, i) => (
                    <div key={i} className="col-xs-6 col-sm-4 col-md-4">
                      <TeamMembersCard key={data.id} data={data} />
                    </div>
                  ))
                }
              
            </div>
          </div>
        </div>

        {/* <TeamMembersCard/> */}

        {/* <div className="row">
            {teamMembers.map(function(item) {
              return (
                <TeamMembersCard
                  key={item.id}
                  data={item}  
                />
              );
            })}
          </div> */}
       
      </Layout>
    </>
  );
};

export default TeamMembersPage;
